import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'

const CollectiveLogDataOnAnnouncementCreated: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnAnnouncementCreated'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    isLast={isLast}
    bundle={bundledCollectiveLog}
    summaryActionText={`posted 
          ${
            bundledCollectiveLog.logs.length > 1
              ? `${bundledCollectiveLog.logs.length} announcements`
              : `an announcement`
          }     
    `}
    detailsActionText={log =>
      `posted an announcement: "${log.data.announcement.bodyHtml?.replace(
        /(<([^>]+)>)/gi,
        ''
      )}"`
    }
  />
)

export default CollectiveLogDataOnAnnouncementCreated
